import { de } from 'date-fns/locale';
import { LocaleDefinition } from '../localeDefinition';
import messages from './de.json';

const definition: LocaleDefinition = {
  code: 'de-DE',
  messages,
  dateFnsLocale: de,
};

export default definition;
